import { Directive, Input } from '@angular/core';
import { CdkTreeNodeToggle } from '@angular/cdk/tree';

@Directive({
  selector: '[mcraiTreeNodeToggle]',
  host: {
    '(click)': '_toggle($event)',
  },
  providers: [{ provide: CdkTreeNodeToggle, useExisting: ToggleDirective }]
})
export class ToggleDirective<T> extends CdkTreeNodeToggle<T> {

  @Input('mcraiTreeNodeToggleRecursive') recursive: boolean = true;

}